
<div class=" d-none d-sm-block">
	<!------------------------------------------TITLE----------------------------------------------->
	<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
		<div class="head-card p-1 inner-title-box">
		  <h1 class="title-text text-center font-weight-bold">
			PANEL AIR COOLER
		  </h1>
		  <div class="text-right">
			<h5 class="text-light">
				<span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
				<span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
				<span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
				<span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
			</h5>
		  </div>
		</div>
	   </div>

	  <!--------------------------------------------------TITLE END-------------------------------------------->
	<!------------------------------------------------------------CAROSUEL----------------------------------------------------->
	<div class="content-container">   
		<a class="mail-call" href="tel:8489359948">
            <span class="fa fa-phone" aria-hidden="true"></span>
        </a>  
		<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
		</a>   
		<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
			<span class="fa fa-whatsapp"></span>
		</a>
        <img src="../../../assets/img/active-service/panel-air-cooler.jpeg" alt="">
        <br>
        <ul>
            <li>A panel air conditioner (AC) is used with a CNC machine because the control panel of a CNC machine contains
                 sensitive electronic components like drives, PLCs, and transformers which generate significant heat, and a panel
                  AC helps maintain a stable, cool temperature within the 
                panel to prevent overheating and ensure reliable operation of the machine, especially when high precision is required. 

            &nbsp;Key reasons for using a panel AC with a CNC machine:
            Protection against heat damage:
            Electronic components in the control panel can malfunction or fail if
             they get too hot, which can be prevented by a panel AC keeping the temperature within an optimal range. </li>
        </ul>
        <img src="../../../assets/img/active-service/panel-ac1.jpeg" alt="">


        <p>
          usage application: cnc and vmc machine and electical panel
            Maintaining accuracy:
Temperature fluctuations can lead to dimensional changes in the workpiece due to thermal expansion, 
so a stable temperature controlled by a panel AC helps maintain machining accuracy. 
        <p>
            Dust and humidity control:
            Many panel ACs also filter dust and control humidity, which is crucial for protecting sensitive electronic components. 
            Long-term reliability:
            By preventing overheating and maintaining a clean environment,
             a panel AC can significantly extend the lifespan of the CNC machine's control panel.
        </p>
    </div>
</div>




<!--------------------------------------- MOBILE VIEW ------------------------------------------------->

<div class=" d-block d-sm-none">
	<a class="mail-call" href="tel:8489359948">
		<span class="fa fa-phone" aria-hidden="true"></span>
	</a>  
	<a class="mail-call1" href="mailto:rvproduction2017@gmail.com"><span class="fa fa-envelope"></span>
	</a>   
	<a class="mail-call2" href="https://wa.me/8489359948" target="_blank">
		<span class="fa fa-whatsapp"></span>
	</a>
    <img src="../../assets/img/multi-brand/multibrand7.webp" alt="">
    <br>
    <ul>
        <li>Panel air coolers are designed to regulate temperature in electrical panels
             and enclosures, preventing overheating of critical components. They use evaporative cooling to lower the temperature inside panels, ensuring the proper functioning of sensitive electronic equipment and prolonging their lifespan.

        &nbsp;Ideal for industrial environments, control rooms, server rooms, manufacturing units, and electrical substations where temperature
         control is crucial for equipment reliability and performance.
         Panel air coolers play a critical role in maintaining the right temperature within control panels. Regular servicing ensures optimal 
         airflow, prevents system failures, and helps avoid costly downtime.</li>
    </ul>



    <p>
        Installation & Setup – Proper installation of new panel air coolers to ensure efficient cooling and integration with existing systems.
    <p>
        Routine Maintenance – Regular checks, cleaning of filters, and inspection of electrical connections to ensure peak performance.
        Repairs & Replacements – Fast troubleshooting and repair of any issues, including fan malfunctions, motor failures, or cooling inefficiencies.
        Energy Efficiency Upgrades – Improving the energy efficiency of existing air coolers to reduce operational costs.
    </p>
    </div>

